import { render, staticRenderFns } from "./MtSupplysList.vue?vue&type=template&id=defb8288&scoped=true&"
import script from "./MtSupplysList.vue?vue&type=script&lang=js&"
export * from "./MtSupplysList.vue?vue&type=script&lang=js&"
import style0 from "./MtSupplysList.vue?vue&type=style&index=0&id=defb8288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defb8288",
  null
  
)

export default component.exports